/**
* CTA JS
* -----------------------------------------------------------------------------
*
* All the JS for the CTA component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import {DrawSVGPlugin} from 'gsap/DrawSVGPlugin.js';
gsap.registerPlugin( ScrollTrigger, DrawSVGPlugin );
( function( app ) {
  const COMPONENT = {

    className: 'cta',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.js-draw-arrow:not(.js-ignore)' ).each( function() {
        const drawPath = $( this ).find( '.js-draw-path' ).get( 0 );
        const arrowHead = $( this ).find( '.arrowHead' ).get( 0 );

        gsap.set( $( drawPath ), {drawSVG: '0%'} );

        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: 'top 90%',
            onRefresh: ( self ) => {
              if ( self.progress > 0 ) {
                $( this ).addClass( 'js-animated' );
              }
            },
            onEnter: ( {progress, direction, isActive} ) => {
              if ( $( this ).hasClass( 'js-fade-group' ) ) {
                $( this ).find( '> *' ).each( function( childKey, child ) {
                  const delay = ( childKey + 1 ) / 10;
                  child.style.setProperty( '--fade-group-delay', delay + 's' );
                } );
              }
              $( this ).addClass( 'js-animated' );
            },
          },
        } );

        tl.to( $( drawPath ), {drawSVG: '100%', duration: 3} );

        tl.from( arrowHead, {
          opacity: 0, // optional fade in
          duration: 1, // seconds
          ease: 'power2.out',
        }, '-=0.1' );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'cta', COMPONENT );
} )( app );
